import { render, staticRenderFns } from "./WorkIconCheckboxSelect.vue?vue&type=template&id=2211c450"
import script from "./WorkIconCheckboxSelect.vue?vue&type=script&lang=js"
export * from "./WorkIconCheckboxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports